const stopStream = (stream) => {
  const isValidStream = Boolean(stream instanceof MediaStream);

  if (!isValidStream) {
    return;
  }

  stream.getTracks().forEach((track) => {
    track.stop();
  });
}

export {
  stopStream,
}
